import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from "../ui/dialog";
import { ReturnRequest } from "@/interfaces/Return";
import Package from "../colis/Colis";
import { ScrollArea } from "../ui/scroll-area";

interface RequestProductDetailsDialogProps {
  isOpened: boolean;
  handleClose: () => void;
  request: ReturnRequest;
}

export const RequestProductDetailsDialog: React.FC<
  RequestProductDetailsDialogProps
> = ({ isOpened, handleClose, request }) => {
  return (
    <Dialog open={isOpened} onOpenChange={handleClose}>
      <DialogOverlay style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }} />
      <DialogContent hasClose className="h-2x max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <div className="flex justify-start">
              <p className="text-lg font-semibold">Détails</p>
            </div>
          </DialogTitle>
          <ScrollArea className="flex-1 max-h-[400px]" showScrollIndicator>
            {request.colis &&
              request.colis.map((colis, index) => (
                <Package key={index} colis={colis} />
              ))}
          </ScrollArea>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
